const MaximumAwardsDataset = {
    user: "Maximum Number",
    awardArr: [{awardType: "Badge", awardCount: 14},
               {awardType: "Bronze", awardCount: 4},
               {awardType: "Silver", awardCount: 4},
               {awardType: "Gold",   awardCount: 4},
               {awardType: "Jewel",  awardCount: 4},
               {awardType: "ExtraCredit", awardCount: 7}
    ]
}
export default MaximumAwardsDataset;